import { TIMEZONES } from '@flexible-reports/utils/timezone/timezone-constants';
import { getTimezone } from '@urc-ui/services/app-context';
import { getTimezoneOffset } from 'date-fns-tz';
import { logger } from '@flexible-reports/services/logger';

export const getCoercedTimezone = (): TIMEZONES => {
  const browserTimezone = getTimezone();
  if (browserTimezone in TIMEZONES) {
    return browserTimezone as TIMEZONES;
  }

  try {
    const closestTimezone = findClosestSupportedTimezone(browserTimezone);
    logger.logErrorMessage(`Timezone not supported by TADA Domain Model. Falling back to closest Timezone: ${closestTimezone}`, {
      browserTimezone,
      closestTimezone
    });
    return closestTimezone;
  } catch (error) {
    const defaultTimezone = TIMEZONES['UTC'];
    logger.logErrorMessage(`There was an error while computing closest timezone for browserTimezone: ${browserTimezone},
     falling back to ${defaultTimezone}`);
    return defaultTimezone;
  }
};

const findClosestSupportedTimezone = (inputTimezone: string): TIMEZONES => {
  const inputOffset = getTimezoneOffset(inputTimezone);

  // We will start with UTC, Because the offset calculation for a completely random string 'RANDOM' returns NaN,
  // so the default timezone UTC will be returned after evaluating offsets
  let closestTimezone = TIMEZONES['UTC'];
  let smallestDifference = Infinity;

  for (const timezone of Object.values(TIMEZONES)) {
    const tzOffset = getTimezoneOffset(timezone);
    const difference = Math.abs(inputOffset - tzOffset);

    if (difference < smallestDifference) {
      smallestDifference = difference;
      closestTimezone = timezone as TIMEZONES;
    }
  }

  return closestTimezone;
};
